import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideState, provideStore } from '@ngrx/store';
import { dataReducer } from './storage/Lead/data.reducer';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideEffects } from '@ngrx/effects';
import { metaReducers } from './storage/meta-reducers';
import { APP_BASE_HREF } from '@angular/common';
import { cotizacionReducer } from './storage/Cotizacion/cotizacion.reducer';
import { planesReducer } from './storage/Planes/planes.reducers';
import { UrlValidatorService, validateUrlFactory } from './shared/services/url-validator-service';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { errorHandlerInterceptor } from './shared/interceptors/error-handler.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorHandlerInterceptor])),
    provideStore({ dataReducer }, { metaReducers }),
    provideStoreDevtools({ maxAge: 15 }),
    provideEffects(),
    provideState('dataReducer', dataReducer),
    provideState('planesReducer', planesReducer),
    provideState('cotizacionReducer', cotizacionReducer),
    {
      provide: APP_INITIALIZER,
      useFactory: validateUrlFactory,
      deps: [UrlValidatorService],
      multi: true,
    },
  ],
};
